import { useState } from 'react';
import FaqSchema from '../seo/FaqSchema';

/**
 * FaqSection — accessible accordion FAQ with inline FAQPage JSON-LD schema.
 *
 * Props:
 *   heading — section heading (optional)
 *   faqs    — array of { question: string, answer: string }
 *
 * The component both renders the visible FAQ UI AND injects the FAQPage
 * structured data, so callers only need one import.
 */
function FaqSection({ heading = 'Frequently Asked Questions', faqs = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => setOpenIndex((prev) => (prev === idx ? null : idx));

  if (!faqs.length) return null;

  return (
    <>
      {/* Machine-readable schema injected inline */}
      <FaqSchema faqs={faqs} />

      <section className="faq-section section" aria-labelledby="faq-heading">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">

              <h2 className="section-title text-center mb-5" id="faq-heading">
                {heading}
              </h2>

              <dl className="faq-list">
                {faqs.map((faq, idx) => {
                  const isOpen = openIndex === idx;
                  const panelId = `faq-panel-${idx}`;
                  const btnId   = `faq-btn-${idx}`;
                  return (
                    <div
                      key={faq.question}
                      className={`faq-item${isOpen ? ' faq-item--open' : ''}`}
                    >
                      <dt className="faq-item__question">
                        <button
                          id={btnId}
                          type="button"
                          className="faq-item__toggle"
                          aria-expanded={isOpen}
                          aria-controls={panelId}
                          onClick={() => toggle(idx)}
                        >
                          {faq.question}
                          <span className="faq-item__icon" aria-hidden="true">
                            {isOpen ? '−' : '+'}
                          </span>
                        </button>
                      </dt>
                      <dd
                        id={panelId}
                        role="region"
                        aria-labelledby={btnId}
                        className="faq-item__answer"
                        hidden={!isOpen}
                      >
                        <p>{faq.answer}</p>
                      </dd>
                    </div>
                  );
                })}
              </dl>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FaqSection;
